import React from 'react';

import { Chart as ChartJS, CategoryScale, LinearScale, BarElement } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { useThemeContext, InfoBox } from '@infoods/lifebase-ui';

import { ScoreLegend } from './ScoreLegend/ScoreLegend';
import { getChartOption } from './AvgPerformanceScoreChart.settings';
import { usePerformanceScoreChart } from './hooks/usePerformanceScoreChart';

ChartJS.register(CategoryScale, LinearScale, BarElement);

const AvgPerformanceScoreChart = () => {
  const { palette } = useThemeContext();

  const chartData = usePerformanceScoreChart(palette);

  return (
    <InfoBox title="Avg Performance Score" adornment={<ScoreLegend />} customMargin>
      <Bar
        data={chartData}
        plugins={[ChartDataLabels]}
        options={getChartOption(palette)}
      />
    </InfoBox>
  );
};

export { AvgPerformanceScoreChart };
